import { FormTemplate } from "db/definitions";
import { sortByAlphaNumericalArray } from "./sort";

/**
 * Attempts to match templates based on the provided search property
 * This will first check the formTemplateGroup (full match), then the template (includes), then the templateName (includes)
 * If more fancy searching needs to be done please do it here!
 * @param templates that need to be filtered.
 * @param search that the templates need to be filtered by.
 */
function handleSearchTemplates(templates: Record<string, FormTemplate[]>, search: string) {
	const uppercaseLettersSearch = search.replace(/[^a-zA-Z ]/g, "").toUpperCase();

	const final: Record<string, FormTemplate[]> = {};

	// now we gotta go through them all again to make sure
	const templateGroups = sortByAlphaNumericalArray({ array: Object.keys(templates) });
	for (let j = 0; j < templateGroups.length; j++) {
		const templateGroupKey = templateGroups[j];
		const templatesInTemplateGroup = templates[templateGroupKey];
		const templateGroupData = sortByAlphaNumericalArray({ array: templatesInTemplateGroup, key: "template" });
		for (let i = 0; i < templateGroupData.length; i++) {
			const template = templateGroupData[i];
			const trimmedTemplate = template.template.replace(/[^a-zA-Z ]/g, "").toUpperCase();
			const trimmedTemplateName = template.templateName?.replace(/[^a-zA-Z ]/g, "").toUpperCase();
			let matchFound;
			// do the checks here!
			if (template.formTemplateGroup === uppercaseLettersSearch) {
				matchFound = template;
			} else if (trimmedTemplate.includes(uppercaseLettersSearch)) {
				matchFound = template;
			} else if (trimmedTemplateName && trimmedTemplateName.includes(uppercaseLettersSearch)) {
				matchFound = template;
			}

			if (matchFound) {
				// check if the formTemplateGroup is already added.
				if (final[matchFound.formTemplateGroup]) {
					// it is
					final[matchFound.formTemplateGroup].push(matchFound);
				} else {
					// it is not
					final[matchFound.formTemplateGroup] = [matchFound];
				}
			}
		}
	}

	return final;
}

export default handleSearchTemplates;
